export enum EnumServicio {
  ServicioInvalido = 0,
  Regasificacion = 1,
  CargaCisterna = 2,
  CargaBuque = 3,
  EntradaRT = 4,
  SalidaCI = 5,
  CapacidadAlmacenamiento = 6,
  GrupoDistribucion1Cliente = 7,
  CompraVenta = 8,
  Inyeccion = 9,
  Extraccion = 10,
  GrupoDistribucion2Cliente = 12,
  GrupoDistribucion3Cliente = 13,
  RegasificacionTransporte = 15,
  GrupoDistribucion1Transportista = 16,
  GrupoDistribucionAlta = 17,
  GrupoDistribucionBaja = 18,
  DistribucionClienteFinal = 19,
  DistribucionDistribuidor = 20,
  Licuefaccion = 30,
  AlmacenamientoGNL = 31,
  AlmacenamientoPVB = 32,
  DescargaBuque = 33,
  Outras = 34,
  Mensal = 35,
  CurtasUtilizaçoes = 36,
  LongasUtilizaçoes = 37,
  FlexivelMensal = 38,
  FlexivelAnual = 39,
  MPMensal = 40,
  MPCurtasUtilizaçoes = 41,
  MPLongasUtilizaçoes = 42,
  MPFlexivelMensal = 43,
  MPFlexivelAnual = 44,
  AlmacenamientoGN = 45,
  CargaCisternaGasineras = 46,
  EntradaRTDistribucion = 47,
  DistribucionClienteExtendido = 48
}
